// TICKET: https://npco-dev.atlassian.net/browse/TECH-396
// Should move these URLs to a separate nx library
export const PROMOTION_TERMS_CONDITIONS_URL =
  'https://www.myzeller.com/promotion-terms-conditions'
export const PRODUCT_DISCLOSURE_STATEMENT_URL =
  'https://www.myzeller.com/product-disclosure-statement-enhanced-zeller-payment-services'
export const FINANCIAL_SERVICE_GUIDE_URL =
  'https://www.myzeller.com/financial-services-guide'
